import ChannelMailSetting from '@@types/ChannelMailSetting';
import { StringTMap } from '@@types/common';

import { api } from '~/stores/providers/Api2';
import { isNonEmpty } from '~/utils/fnUtil/fnUtil';
import { action, observable } from 'mobx';
import { curry, isNil, pick, propOr, tap } from 'ramda';

class ChannelMailSettingStore {
  @observable
  map: StringTMap<ChannelMailSetting> = {};

  fetchCandidate = (channelId: string) => {
    return api.channel.fetchChannelMailSetting(channelId).then(tap(this.setMailCandidate(channelId)));
  };

  getOrFetch = (channelId) => {
    const mailSetting = this.getMailSetting(channelId);
    return isNonEmpty(mailSetting) ? Promise.resolve(mailSetting) : this.fetchCandidate(channelId);
  };

  getMailSetting = (channelId) => {
    return this.map[channelId];
  };

  @action
  setMailCandidate = curry((channelId, setting) => {
    if (isNil(this.map[channelId])) {
      this.map[channelId] = {
        enabled: true,
        emailAddress: null,
        emailAddressCandidate: null,
        emailDescription: null,
        emailSetAt: null,
        emailTitle: null,
        memberId: null,
      };
    }
    this.map[channelId].emailAddressCandidate = propOr('', 'emailAddressCandidate')(setting);
  });

  @action
  setMailSetting = curry((channelId: string, setting: ChannelMailSetting) => {
    this.map[channelId] = setting;
  });

  @action
  clearMailSetting = (channelId: string) => {
    this.map[channelId] = pick(['enabled'], this.map[channelId]) as ChannelMailSetting;
  };
}

export default ChannelMailSettingStore;

export const channelMailSettingStore = new ChannelMailSettingStore();
